// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .navbar {
  display: none;
} */

/* Grid layout for the main admin page */
.admin-page {
  display: grid;
  grid-template-columns: 250px 1fr;
  height: 100vh;
  width: 100vw;
}

/* Style for the user avatar image */
.admin-page .avatar img {
  height: 2.5rem;
  width: auto;
  margin-top: 1rem;
}

/* Export to CSV Button */
.exportBtn-container {
  gap: 0;
  margin-bottom: 0 !important;
}

.exportBtn {
  width: -moz-max-content;
  width: max-content;
  height: auto;
  border-radius: 20px;
  margin: 1rem;
  border: none;
  box-shadow: 1px 1px rgba(107, 221, 215, 0.37);
  padding: 5px 10px;
  background: rgb(47, 93, 197);
  background: linear-gradient(
    160deg,
    rgba(47, 93, 197, 1) 0%,
    rgba(46, 86, 194, 1) 5%,
    rgba(47, 93, 197, 1) 11%,
    rgba(59, 190, 230, 1) 57%,
    rgba(0, 212, 255, 1) 71%
  );
  color: #fff;
  font-family: Roboto, sans-serif;
  font-weight: 505;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  filter: drop-shadow(0 0 10px rgba(59, 190, 230, 0.568));
  transition: 0.5s linear;
}

.exportBtn .mysvg {
  display: none;
}

.exportBtn:hover {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  transition: 0.5s linear;
}

.exportBtn:hover .texto {
  display: none;
}

.exportBtn:hover .mysvg {
  display: inline;
}

.exportBtn:hover::before {
  content: "";
  position: absolute;
  top: -3px;
  left: -3px;
  width: 100%;
  height: 100%;
  border: 3.5px solid transparent;
  border-top: 3.5px solid #fff;
  border-right: 3.5px solid #fff;
  border-radius: 50%;
  animation: animateC 2s linear infinite;
}

@keyframes animateC {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* The main drawer (sidebar) styles */
.drawer {
  display: flex;
  flex: 1;
}

/* Hide toggle and button for the sidebar */
.drawer-toggle,
.drawer-button {
  display: none;
}

/* Sidebar container styles */
.drawer-side {
  grid-column: 1;
  background-color: #5f6061;
  padding-top: 2rem;
  font-size: 1.25rem;
  position: relative;
}

/* Adjust the drawer-side when collapsed */
.drawer-side.collapsed {
  width: 80px;
}

.drawer-side.collapsed + .drawer-content {
  grid-column-start: 2;
}

/* Style for the navigation menu */
.menu {
  display: flex;
  flex-direction: column;
  padding: 0;
  height: 100%;
  list-style: none;
}

/* Individual list item styles */
.menu .dashboard-title {
  color: #ffffff;
  font-size: 1.6rem;
  font-weight: bolder;
  padding: 1rem;
  margin-bottom: 1rem;
}

.menu li {
  border-bottom: 1px solid #707070;
  color: #d1d5db;
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: background-color 0.3s;
  padding: 1rem;
  gap: 0.5rem;
}

.menu li:last-child {
  border-bottom: none;
}

/* Styles for each anchor link in the sidebar */
.menu li a {
  color: #d1d5db;
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: background-color 0.3s;
  padding: 2rem;
  gap: 0.5rem;

  &:hover {
    background-color: #505050;
    color: #ffffff;
    transition: ease-in-out 0.3s;
  }
}

/* Active state for the anchor link */
.menu li a.active {
  background-color: #505050;
  color: #10b981;
  position: relative;
  font-weight: bold;
  transform: scale(1.4);
  margin-left: 1.5vw;
  transition: ease-in-out 0.3s;
}

/* Before pseudo-element for active link indicator */
.menu li a.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background-color: #10b981;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
/* .admin-page-header {
  display: flex;
  justify-content: center;
  align-self: center;
  padding: 8px;
  font-size: 3rem;
  color: white;
} */

/* Styles for the main content area */
.drawer-content {
  grid-column: 2;
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 1rem;
  background-color: #505050;
}

/* Container for the statistics */
.stats-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

/* Styles for each stat */
.stat {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: 85vw;
}

/* Style for elements inside each stat */
.stat > * {
  margin-right: 1rem;
}

/* Styles for the icons in the stats */
.stat-figure,
.stat svg {
  color: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 7rem;
  height: 7rem;
}

/* Text styles for the title, value, and description in stats */
.stat-title,
.stat-value,
.stat-desc {
  color: #000000;
  margin-top: 0.5rem;
}

.stat-title {
  font-weight: bold;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: bold;
}

.stat-desc {
  font-size: 0.875rem;
}

/* Style for the collapse/expand toggle container */
.collapse-expand-toggle {
  cursor: pointer;
  width: 2rem;
  height: 100%;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background-color: #333;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  transition: all 0.3s ease;

  &:hover {
    background-color: #939393;
  }
}

/* Adjust the drawer-side when collapsed */
.drawer-side.collapsed {
  width: 80px;
}

.drawer-side.collapsed .menu .dashboard li {
  font-size: 0;
  padding: 1rem 2rem 1rem 0;
  justify-content: center;
}

.drawer-side.collapsed .menu .dashboard li a {
  justify-content: center;
  padding: 0.5rem;
}

/* Responsive design adjustments */
@media (max-width: 991px) {
  .admin-page {
    grid-template-columns: 1fr;
  }

  .drawer {
    width: 100vw;
    grid-column: 1 / -1;
  }

  .drawer-side,
  .drawer-content {
    grid-column: 1;
    grid-row: auto;
  }

  .drawer-toggle:checked ~ .drawer-side {
    position: absolute;
    left: 0;
    top: 0;
    width: 250px;
    height: 100%;
    z-index: 100;
  }

  .drawer-content {
    grid-column: 1;
    grid-row: 2;
  }

  .drawer-button {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 101;
  }

  .collapse-expand-toggle {
    display: none;
  }

  .admin-page .menu li {
    font-size: 0;
    display: flex;
    justify-content: center;
  }

  .admin-page .menu li a {
    padding: 0.5rem;
  }

  .admin-page .menu li a.active {
    transform: scale(1.5);
  }

  .stats-container {
    grid-template-columns: 1fr;
    padding: 1rem;
  }

  .stat {
    width: 100%;
    margin: 1rem 0;
  }

  /* Targeting SVG icons within the menu links */
  .admin-page .menu li svg,
  .admin-page .menu li a svg {
    width: 35px;
    height: 35px;
  }

  .exportBtn-container {
    margin-left: 0;
  }

  .exportBtn {
    transform: scale(2);
    margin-left: 8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/AdminPage.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH,wCAAwC;AACxC;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,MAAM;EACN,2BAA2B;AAC7B;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,6CAA6C;EAC7C,iBAAiB;EACjB,4BAA4B;EAC5B;;;;;;;GAOC;EACD,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,uDAAuD;EACvD,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,OAAO;AACT;;AAEA,2CAA2C;AAC3C;;EAEE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iCAAiC;EACjC,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iCAAiC;EACjC,aAAa;EACb,WAAW;;EAEX;IACE,yBAAyB;IACzB,cAAc;IACd,4BAA4B;EAC9B;AACF;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;;;;;;;GAOG;;AAEH,qCAAqC;AACrC;EACE,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,yCAAyC;EACzC,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;;EAEE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA,+DAA+D;AAC/D;;;EAGE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,yBAAyB;;EAEzB;IACE,yBAAyB;EAC3B;AACF;;AAEA,0CAA0C;AAC1C;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA,8CAA8C;EAC9C;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;AACF","sourcesContent":["/* .navbar {\n  display: none;\n} */\n\n/* Grid layout for the main admin page */\n.admin-page {\n  display: grid;\n  grid-template-columns: 250px 1fr;\n  height: 100vh;\n  width: 100vw;\n}\n\n/* Style for the user avatar image */\n.admin-page .avatar img {\n  height: 2.5rem;\n  width: auto;\n  margin-top: 1rem;\n}\n\n/* Export to CSV Button */\n.exportBtn-container {\n  gap: 0;\n  margin-bottom: 0 !important;\n}\n\n.exportBtn {\n  width: max-content;\n  height: auto;\n  border-radius: 20px;\n  margin: 1rem;\n  border: none;\n  box-shadow: 1px 1px rgba(107, 221, 215, 0.37);\n  padding: 5px 10px;\n  background: rgb(47, 93, 197);\n  background: linear-gradient(\n    160deg,\n    rgba(47, 93, 197, 1) 0%,\n    rgba(46, 86, 194, 1) 5%,\n    rgba(47, 93, 197, 1) 11%,\n    rgba(59, 190, 230, 1) 57%,\n    rgba(0, 212, 255, 1) 71%\n  );\n  color: #fff;\n  font-family: Roboto, sans-serif;\n  font-weight: 505;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  filter: drop-shadow(0 0 10px rgba(59, 190, 230, 0.568));\n  transition: 0.5s linear;\n}\n\n.exportBtn .mysvg {\n  display: none;\n}\n\n.exportBtn:hover {\n  width: 75px;\n  height: 75px;\n  border-radius: 50%;\n  transition: 0.5s linear;\n}\n\n.exportBtn:hover .texto {\n  display: none;\n}\n\n.exportBtn:hover .mysvg {\n  display: inline;\n}\n\n.exportBtn:hover::before {\n  content: \"\";\n  position: absolute;\n  top: -3px;\n  left: -3px;\n  width: 100%;\n  height: 100%;\n  border: 3.5px solid transparent;\n  border-top: 3.5px solid #fff;\n  border-right: 3.5px solid #fff;\n  border-radius: 50%;\n  animation: animateC 2s linear infinite;\n}\n\n@keyframes animateC {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* The main drawer (sidebar) styles */\n.drawer {\n  display: flex;\n  flex: 1;\n}\n\n/* Hide toggle and button for the sidebar */\n.drawer-toggle,\n.drawer-button {\n  display: none;\n}\n\n/* Sidebar container styles */\n.drawer-side {\n  grid-column: 1;\n  background-color: #5f6061;\n  padding-top: 2rem;\n  font-size: 1.25rem;\n  position: relative;\n}\n\n/* Adjust the drawer-side when collapsed */\n.drawer-side.collapsed {\n  width: 80px;\n}\n\n.drawer-side.collapsed + .drawer-content {\n  grid-column-start: 2;\n}\n\n/* Style for the navigation menu */\n.menu {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  height: 100%;\n  list-style: none;\n}\n\n/* Individual list item styles */\n.menu .dashboard-title {\n  color: #ffffff;\n  font-size: 1.6rem;\n  font-weight: bolder;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.menu li {\n  border-bottom: 1px solid #707070;\n  color: #d1d5db;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  transition: background-color 0.3s;\n  padding: 1rem;\n  gap: 0.5rem;\n}\n\n.menu li:last-child {\n  border-bottom: none;\n}\n\n/* Styles for each anchor link in the sidebar */\n.menu li a {\n  color: #d1d5db;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  transition: background-color 0.3s;\n  padding: 2rem;\n  gap: 0.5rem;\n\n  &:hover {\n    background-color: #505050;\n    color: #ffffff;\n    transition: ease-in-out 0.3s;\n  }\n}\n\n/* Active state for the anchor link */\n.menu li a.active {\n  background-color: #505050;\n  color: #10b981;\n  position: relative;\n  font-weight: bold;\n  transform: scale(1.4);\n  margin-left: 1.5vw;\n  transition: ease-in-out 0.3s;\n}\n\n/* Before pseudo-element for active link indicator */\n.menu li a.active::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 5px;\n  background-color: #10b981;\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n/* .admin-page-header {\n  display: flex;\n  justify-content: center;\n  align-self: center;\n  padding: 8px;\n  font-size: 3rem;\n  color: white;\n} */\n\n/* Styles for the main content area */\n.drawer-content {\n  grid-column: 2;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  padding: 1rem;\n  background-color: #505050;\n}\n\n/* Container for the statistics */\n.stats-container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n}\n\n/* Styles for each stat */\n.stat {\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  width: 85vw;\n}\n\n/* Style for elements inside each stat */\n.stat > * {\n  margin-right: 1rem;\n}\n\n/* Styles for the icons in the stats */\n.stat-figure,\n.stat svg {\n  color: #3b82f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 7rem;\n  height: 7rem;\n}\n\n/* Text styles for the title, value, and description in stats */\n.stat-title,\n.stat-value,\n.stat-desc {\n  color: #000000;\n  margin-top: 0.5rem;\n}\n\n.stat-title {\n  font-weight: bold;\n}\n\n.stat-value {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.stat-desc {\n  font-size: 0.875rem;\n}\n\n/* Style for the collapse/expand toggle container */\n.collapse-expand-toggle {\n  cursor: pointer;\n  width: 2rem;\n  height: 100%;\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  background-color: #333;\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 10;\n  transition: all 0.3s ease;\n\n  &:hover {\n    background-color: #939393;\n  }\n}\n\n/* Adjust the drawer-side when collapsed */\n.drawer-side.collapsed {\n  width: 80px;\n}\n\n.drawer-side.collapsed .menu .dashboard li {\n  font-size: 0;\n  padding: 1rem 2rem 1rem 0;\n  justify-content: center;\n}\n\n.drawer-side.collapsed .menu .dashboard li a {\n  justify-content: center;\n  padding: 0.5rem;\n}\n\n/* Responsive design adjustments */\n@media (max-width: 991px) {\n  .admin-page {\n    grid-template-columns: 1fr;\n  }\n\n  .drawer {\n    width: 100vw;\n    grid-column: 1 / -1;\n  }\n\n  .drawer-side,\n  .drawer-content {\n    grid-column: 1;\n    grid-row: auto;\n  }\n\n  .drawer-toggle:checked ~ .drawer-side {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 250px;\n    height: 100%;\n    z-index: 100;\n  }\n\n  .drawer-content {\n    grid-column: 1;\n    grid-row: 2;\n  }\n\n  .drawer-button {\n    display: block;\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 101;\n  }\n\n  .collapse-expand-toggle {\n    display: none;\n  }\n\n  .admin-page .menu li {\n    font-size: 0;\n    display: flex;\n    justify-content: center;\n  }\n\n  .admin-page .menu li a {\n    padding: 0.5rem;\n  }\n\n  .admin-page .menu li a.active {\n    transform: scale(1.5);\n  }\n\n  .stats-container {\n    grid-template-columns: 1fr;\n    padding: 1rem;\n  }\n\n  .stat {\n    width: 100%;\n    margin: 1rem 0;\n  }\n\n  /* Targeting SVG icons within the menu links */\n  .admin-page .menu li svg,\n  .admin-page .menu li a svg {\n    width: 35px;\n    height: 35px;\n  }\n\n  .exportBtn-container {\n    margin-left: 0;\n  }\n\n  .exportBtn {\n    transform: scale(2);\n    margin-left: 8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
